import Phaser from 'phaser';
import { WORLD } from '../data/balance';
import { BootScene } from '../scenes/BootScene';
import { HudScene } from '../scenes/HudScene';
import { PlayScene } from '../scenes/PlayScene';
import { TitleScene } from '../scenes/TitleScene';

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-root',
  width: WORLD.viewWidth,
  height: WORLD.viewHeight,
  backgroundColor: '#0d0d14',
  pixelArt: true,
  roundPixels: true,
  antialias: false,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    activePointers: 4,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: WORLD.gravity },
      debug: false,
    },
  },
  scene: [BootScene, TitleScene, PlayScene, HudScene],
};
